export default "__VITE_ASSET__D_FPP4PP__"